import '../../../../../FE/src/assets/javascripts/libs/slick.js';

export default class ClientsCarousel {
  constructor(el) {
    this.$this = $(el);
    this.$carousel = this.$this.find('.gravity-clients__carousel-inner');
    this.$prevArrow = this.$this.find('.gravity-clients__nav-arrow--prev');
    this.$nextArrow = this.$this.find('.gravity-clients__nav-arrow--next');
    this.$pagination = this.$this.find('.gravity-clients__pagination');
  }

  init() {
    if (this.$carousel.length && this.$carousel.find('.gravity-clients__slide').length > 0) {
      this.initCarousel();
      this.handleResize();
    }
  }

  initCarousel() {
    // Destroy existing carousel if any
    if (this.$carousel.hasClass('slick-initialized')) {
      this.$carousel.slick('unslick');
    }

    const windowWidth = window.innerWidth;
    
    // Determine which slides to show based on breakpoint
    let slideSelector = '.gravity-clients__slide--desktop'; // Desktop default
    
    if (windowWidth < 768) {
      slideSelector = '.gravity-clients__slide--mobile'; // Mobile
    } else if (windowWidth <= 1024) {
      slideSelector = '.gravity-clients__slide--tablet'; // Tablet
    }

    // Initialize Slick carousel with appropriate slide selector
    this.$carousel.slick({
      rows: 0,
      slide: slideSelector,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      arrows: true,
      dots: true,
      prevArrow: this.$prevArrow,
      nextArrow: this.$nextArrow,
      appendDots: this.$pagination,
      adaptiveHeight: false,
      swipe: true,
      touchMove: true,
      speed: 500,
      cssEase: 'ease',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slide: '.gravity-clients__slide--tablet'
          }
        },
        {
          breakpoint: 768,
          settings: {
            slide: '.gravity-clients__slide--mobile'
          }
        }
      ]
    });

    // Update arrow states based on carousel position
    this.$carousel.on('afterChange', (event, slick, currentSlide) => {
      this.updateArrowStates(currentSlide, slick.slideCount);
    });

    // Initial arrow state
    this.updateArrowStates(0, this.$carousel.slick('getSlick').slideCount);
  }

  updateArrowStates(currentSlide, totalSlides) {
    if (currentSlide === 0) {
      this.$prevArrow.prop('disabled', true);
    } else {
      this.$prevArrow.prop('disabled', false);
    }

    if (currentSlide === totalSlides - 1) {
      this.$nextArrow.prop('disabled', true);
    } else {
      this.$nextArrow.prop('disabled', false);
    }
  }

  handleResize() {
    let resizeTimer;
    $(window).on('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        // Reinitialize carousel on resize to handle logo grouping changes
        this.initCarousel();
      }, 250);
    });
  }
}

// Initialize carousel
if (typeof window.acf === 'undefined') {
  $('.gravity-clients').each((_index, el) => {
    new ClientsCarousel(el).init();
  });
} else {
  // ACF preview mode - initialize after block is rendered
  acf.addAction('render_block_preview', function($block) {
    if ($block.hasClass('gravity-clients')) {
      new ClientsCarousel($block[0]).init();
    }
  });
}

